<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link
                v-bind:to="'/aliado/anexos/' + id_aliado"
                class="btn btn-orange rounded-pill"
              >
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
              <br />
            </div>
            <div class="mt-2 mb-3">
              <h3 class="text-orange fw-bold">{{ aliado.nombre_aliado }}</h3>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="text-orange fw-bold">Solicitudes de diseños</h4>
              </div>
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col-lg-12 text-end">
                    <router-link v-bind:to="'/nueva_solicitud_pieza/' + id_aliado"
                      class="btn btn-orange btn-lg rounded-pill">
                      <i class="bx bxs-plus-circle"></i> Nueva solicitud
                    </router-link>
                  </div>
                </div>
                <div v-if="solicitudes.length != 0" class="row">
                  <div v-for="(solicitud, index_solicitud) in solicitudes" v-bind:key="index_solicitud" class="col-lg-12">
                    <div class="card card-body border shadow">
                      <div class="row">
                        <div class="col-lg-3">
                          <label>Fecha de solicitud</label><br />
                          <span class="text-orange fw-bold">{{
                            solicitud.fecha_solicitud
                          }}</span>
                        </div>
                        <div class="col-lg-3">
                          <label>Estado de solicitud</label><br />
                          <span v-if="solicitud.estado_solicitud == 0" class="badge bg-warning">
                            Pendiente
                          </span>
                          <span v-if="solicitud.estado_solicitud == 1" class="badge bg-info">
                            En desarrollo
                          </span>
                          <span v-if="solicitud.estado_solicitud == 2" class="badge bg-primary">
                            Terminada
                          </span>
                          <span v-if="solicitud.estado_solicitud == 4" class="badge bg-success">
                            Aprobada
                          </span>
                          <span v-if="solicitud.estado_solicitud == 5" class="badge bg-danger">
                            Cancelada
                          </span>
                          <span v-if="solicitud.estado_solicitud == 6" class="badge bg-warning">
                            No aprobada
                          </span>
                        </div>
                        <div class="col-lg-3">
                          <label>Piezas</label><br />
                          <span v-if="solicitud.horizontal == 1" class="text-orange fw-bold">
                            <i class="bx bxs-check-circle"></i>
                            Redes sociales </span><br />
                          <span v-if="solicitud.vertical == 1" class="text-orange fw-bold">
                            <i class="bx bxs-check-circle"></i> Revista
                          </span>
                          <span v-if="solicitud.app == 1" class="text-orange fw-bold">
                            <i class="bx bxs-check-circle"></i> App
                          </span>
                        </div>
                        <div class="col-lg-3">
                          <router-link v-bind:to="
                            '/aliado/solicitud/' +
                            solicitud.id_solicitud_pieza
                          " class="btn btn-outline-primary rounded-pill mt-3">
                            <i class="bx bx-list-ul"></i> Detalle
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col-lg-12">
                    <span class="text-muted">
                      <i class="bx bx-info-circle"></i> No se han agregado
                      solicitudes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <router-link v-bind:to="'/aliado/anexos/' + id_aliado" class="btn btn-outline-secondary rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>

              <br />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Solicitudes",
  metaInfo: {
    title: "Solicitudes - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      id_aliado: null,
      aliado: [],
      solicitudes: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
    this.get_solicitudes();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_solicitudes: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url + "aliados/solicitudes_piezas/" + this.id_aliado,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitudes = response.data.data.solicitudes;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
};
</script>
<style scoped>
a.btn.btn-orange.btn-lg.rounded-pill {
  font-size: 21px;
  float: left;
  margin-bottom: 25px;
}
</style>